import 'element-internals-polyfill';
import 'form-request-submit-polyfill';
import { loadTool, ToolsModules } from './toolbox';

// region: component exports
export * from './cas';
export * from './dialog';
export * from './dynamic';
export * from './extras';
export * from './icon';
export * from './forms';
export * from './flow';
export * from './frame';
export * from './info-box';
export * from './layout';
export * from './list';
export * from './module-navigation';
export * from './navigation';
export * from './table';
export * from './timetable';
export * from './tooltip';
export * from './buttons';
export * from './banner';
// endregion: component exports

export * from './events';
export * from './locale';

// install global object

declare global {
    var USOS: {
        UI: Partial<ToolsModules> & {
            version: string,
            loadTool: typeof loadTool,
        },
    };
}

// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
const global = globalThis.USOS || {};
global.UI = {
    version: __VERSION__ as string,
    loadTool,
};
globalThis.USOS = global;
